import type React from 'react';

import type { Location } from '@vlabs/api/luna-api/model';
import { GeoLocation, GeoLocationMarker } from '@vlabs/uikit';
import type { WithDataTestid } from '@vlabs/uikit/types';

import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import st from './AttributesCell.module.sass';

interface AttributesMapProps extends WithDataTestid {
  location?: Location | null;
}

const displayName = 'AttributesMap';
const testid = buildTestid(displayName);
const DEFAULT_CENTER: [number, number] = [0, 0];

interface LocationPoint {
  center: [number, number];
  hasCoordinates: boolean;
}

function getLocationPoint(location?: Location | null): LocationPoint {
  const { latitude, longitude } = location?.geo_position ?? {};

  if (
    latitude === null
    || latitude === undefined
    || longitude === null
    || longitude === undefined
  ) {
    return {
      center: DEFAULT_CENTER,
      hasCoordinates: false,
    };
  }

  return {
    center: [Number(latitude), Number(longitude)],
    hasCoordinates: true,
  };
}

function AttributesMap({
  location = undefined,
  'data-testid': dataTestId = undefined,
}: AttributesMapProps): React.JSX.Element {
  const { center, hasCoordinates } = getLocationPoint(location);
  let marker: React.ReactNode = null;

  if (hasCoordinates) {
    marker = <GeoLocationMarker anchor={center} />;
  }

  return (
    <div
      className={st.Map}
      {...testid(dataTestId)}
    >
      <GeoLocation
        center={center}
        toggleFullScreenMode={false}
      >
        {marker}
      </GeoLocation>
    </div>
  );
}

AttributesMap.displayName = displayName;

export { AttributesMap };
